export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus[TransactionStatus["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    TransactionStatus[TransactionStatus["SUCCESSFUL"] = 2] = "SUCCESSFUL";
    TransactionStatus[TransactionStatus["FAIL"] = 3] = "FAIL";
})(TransactionStatus || (TransactionStatus = {}));
//# sourceMappingURL=TransactionStatus.js.map